import React, { useState } from 'react';
import Modal from 'react-modal';

// Make sure to set the app element for React Modal
Modal.setAppElement('#root');

const InfoIcon = ({ infoData }) => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  const openModal = () => {
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
  };

  return (
    <div>
      {/* Info Icon */}
      <div onClick={openModal} style={{ cursor: 'pointer' }}>
        <span role="img" aria-label="Info">
          ℹ️
        </span>
      </div>

      {/* Modal */}
      <Modal 
        isOpen={isModalOpen}
        onRequestClose={closeModal}
        style={{
          overlay: {
            backgroundColor: 'rgba(0, 0, 0, 0.5)',
          },
          content: {
            width: '600px',
            margin: 'auto',
            marginTop: '100px',
            color:'white',
            background:'#424242'
          },
        }}
      >
        <div>
          {/* Content inside the modal */}
          <h2>Information</h2>
          <p>    {infoData.map((line, index) => (
      <span key={index}>
        {line}
        <br />
      </span>
    ))}
</p>

          {/* Close button */}
          <button style={{background:'#007bfa'}} onClick={closeModal}>Close</button>
        </div>
      </Modal>
    </div>
  );
};

export default InfoIcon;
